export default {
    namespaced: true,
    state: {
        show_menu: false,
        transition: false,
        profileDialog: false
    },
    getters: {
        menuStatus: state => {
            return state.show_menu
        },
        transition: state => {
            return state.transition
        },
        profileDialog: state => {
            return state.profileDialog
        }
    },
    mutations: {
        SET_MENU: (state,payload) => {
            state.show_menu = payload
        },
        SET_TRANSITION: (state,payload) => {
            state.transition = payload
        },
        SET_PROFILE_DIALOG: (state, payload) => {
            state.profileDialog = payload
        }
    },
    actions: {
    }
}